/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Conversations_TitleInputs */

const en_us2_coach_extra_conversations_title = /** @type {(inputs: Coach_Extra_Conversations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations`)
};

const pt_br2_coach_extra_conversations_title = /** @type {(inputs: Coach_Extra_Conversations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversas`)
};

const es_419_coach_extra_conversations_title = /** @type {(inputs: Coach_Extra_Conversations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversaciones`)
};

const pt_pt2_coach_extra_conversations_title = /** @type {(inputs: Coach_Extra_Conversations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversas`)
};

const fr_fr2_coach_extra_conversations_title = /** @type {(inputs: Coach_Extra_Conversations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations`)
};

const de_de2_coach_extra_conversations_title = /** @type {(inputs: Coach_Extra_Conversations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterhaltungen`)
};

const it_it2_coach_extra_conversations_title = /** @type {(inputs: Coach_Extra_Conversations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversazioni`)
};

/**
* | output |
* | --- |
* | "Conversations" |
*
* @param {Coach_Extra_Conversations_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_conversations_title = /** @type {((inputs?: Coach_Extra_Conversations_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Conversations_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_conversations_title(inputs)
	if (locale === "es-419") return es_419_coach_extra_conversations_title(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_conversations_title(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_conversations_title(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_conversations_title(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_conversations_title(inputs)
	return en_us2_coach_extra_conversations_title(inputs)
});
export { coach_extra_conversations_title as "coach-extra.conversations_title" }